// compress method：https://github.com/giscafer/mapshaper-plus
// compressType： echarts-map-json(encode)
// reference：https://github.com/apache/echarts/blob/master/src/coord/geo/parseGeoJson.ts
function decodePolygon(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for (var i = 0; i < coordinate.length; i += 2) {
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64;
        // ZigZag decoding
        x = (x >> 1) ^ -(x & 1);
        y = (y >> 1) ^ -(y & 1);
        // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y;
        // Dequantize
        result.push([x / encodeScale, y / encodeScale]);
    }
    return result;
}
export function decode(json, name) {
    if (!json) {
        throw new Error("map name " + name + " doesn't exist");
    }
    if (!json.UTF8Encoding) {
        return json;
    }
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) {
        encodeScale = 1024;
    }
    var features = jsonCompressed.features;
    for (var f = 0; f < features.length; f++) {
        var feature = features[f];
        var geometry = feature.geometry;
        if (geometry.type === 'Polygon') {
            var coordinates = geometry.coordinates;
            for (var c = 0; c < coordinates.length; c++) {
                coordinates[c] = decodePolygon(coordinates[c], geometry.encodeOffsets[c], encodeScale);
            }
        }
        else if (geometry.type === 'MultiPolygon') {
            var coordinates = geometry.coordinates;
            for (var c = 0; c < coordinates.length; c++) {
                var coordinate = coordinates[c];
                for (var c2 = 0; c2 < coordinate.length; c2++) {
                    coordinate[c2] = decodePolygon(coordinate[c2], geometry.encodeOffsets[c][c2], encodeScale);
                }
            }
        }
    }
    // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
